import React, { forwardRef } from 'react';
import type { ForwardRefType } from '@noths/polaris-dev-ts-recipes';

import { ButtonInner } from '../ButtonInner/ButtonInner';
import type { TextButtonProps } from './types';
import * as styles from './TextButton.styles';

export const TextButton = forwardRef<HTMLButtonElement, TextButtonProps>(
  ({ active, children, ...props }: TextButtonProps, forwardedRef) => (
    <button
      css={styles.textButton}
      data-is-active={active}
      ref={forwardedRef as ForwardRefType<HTMLButtonElement>}
      {...props}
    >
      <ButtonInner>{children}</ButtonInner>
    </button>
  ),
);
